// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"gK-z","carouselContainer":"hK-z"};